export const RANGE_EPWORTH = Object.freeze({
  LOW: `low`,
  MILD: `mild`,
  MODERATE: `moderate`,
  HIGH: `high`,
})

export const BOUNDS_EPWORTH_RESULTS = Object.freeze({
  [RANGE_EPWORTH.LOW]: [`Lower normal`, `Normal`],
  [RANGE_EPWORTH.MILD]: [`Mild`],
  [RANGE_EPWORTH.MODERATE]: [`Moderate`],
  [RANGE_EPWORTH.HIGH]: [`Severe`],
})
